import HeroSection from '../components/public/HeroSection';
import ValuePillars from '../components/public/ValuePillars';
import VisionLeadInSection from '../components/public/VisionLeadInSection';
import SystemOverviewSection from '../components/public/SystemOverviewSection';
import OutcomesSection from '../components/public/OutcomesSection';
import ProgramsSection from '../components/public/ProgramsSection';
import DemoCTA from '../components/public/DemoCTA';
import AboutUsSection from '../components/public/AboutUsSection';

/**
 * PublicHome - Homepage V3
 *
 * Narrative arc:
 * 1. Vision: What decision problem matters in learning
 * 2. System: How Pinpoint Edu makes decisions
 * 3. Outcomes: What learners get as a result
 * 4. Context: Scope, credibility, and contact
 */
const PublicHome = () => {
    return (
        <>
            <HeroSection />
            <ValuePillars />
            <VisionLeadInSection />
            <SystemOverviewSection />
            <OutcomesSection />
            <ProgramsSection />
            <DemoCTA />
            <AboutUsSection />
        </>
    );
};

export default PublicHome;
